import * as amplitude from '@amplitude/unified';
import * as Sentry from '@sentry/react';
import { CircleAlert } from 'lucide-react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

interface ErrorPageProps {
  // Callers pass either a real Error (ErrorBoundary) or a plain
  // { name, message } object (PageLayout coerces string errors into this).
  error: { name?: string; message?: string };
  errorInfo?: React.ErrorInfo | null;
}

const ErrorPage = ({ error, errorInfo = null }: ErrorPageProps) => {
  const location = useLocation();

  useEffect(() => {
    const error_name = error?.name;
    const error_message = error?.message;
    const url = `${location.pathname}${location.search}`;
    amplitude.track('crash', { error_name, error_message, url });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenFeedbackClick = () => {
    Sentry.withScope(scope => {
      // Sentry's Extras is Record<string, unknown>; React.ErrorInfo is an
      // interface (no index signature) so it needs a cast. Runtime-identical.
      scope.setExtras(errorInfo as unknown as Record<string, unknown>);
    });
    const eventId = Sentry.captureException(error);
    Sentry.showReportDialog({ eventId });
  };

  return (
    <React.Fragment>
      <div className="flex h-[67vh] flex-col items-center justify-center text-center">
        <CircleAlert className="size-[100px]" strokeWidth={1.5} />
        <div className="mt-5 text-base">
          <p><b>An unexpected error occurred.</b></p>
          <p>
            Our team has been notified. If you’d like to help, <a href="#" onClick={handleOpenFeedbackClick}>please tell us what happened</a>.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ErrorPage;
